import { Pipe, PipeTransform } from '@angular/core';

/**
 * Filters the elements of an array based on the specified field names and search term.
 * Looks for the search term value in the individual field values of the element. If there
 * is a match, the element is returned otherwise filtered out.
 */
@Pipe({
  name: 'searchFilter',
})
export class SearchFilterPipe implements PipeTransform {
  transform(values: any[], params: string[], searchTerm: string): any[] {
    if (
      this.isEmpty(searchTerm) ||
      this.isEmpty(params) ||
      this.isEmpty(values)
    ) {
      return values;
    }

    const paths: string[][] = [];
    for (const param of params) {
      paths.push(param.split('.'));
    }

   
    const lcSearchText = searchTerm.toLowerCase();
    return values.filter((value) => {
      for (const path of paths) {
        const str = this.getValue(value, path);
        if (str && str.toLowerCase().indexOf(lcSearchText) !== -1) {
          return true;
        }
      }
      return false;
    });
  }


  private isEmpty(v: string | any[]) {
    return !v || v.length === 0;
  }


  private getValue(o: any, path: string[]): string {
    let v = o;
    for (const e of path) {
      v = v[e];
      if (!v) {
        return null;
      }
    }
    return v.toString();
  }
}
